import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { firebaseAuth } from "../firebase/firebaseClient";

/**
 * Redirects to /login when no JWT is present (Redux or localStorage).
 * Prevents visiting /homepage after logout by URL alone.
 */
function RequireAuth({ children }) {
  const location = useLocation();

  // Firebase Auth is the source of truth; fall back to localStorage for refresh edge-cases.
  const user = firebaseAuth.currentUser;
  const hasStoredUser = !!localStorage.getItem("userInfo");

  if (!user && !hasStoredUser) {
    return (
      <Navigate to="/login" replace state={{ from: location.pathname }} />
    );
  }

  return children;
}

export default RequireAuth;
